<template>
  <div class="animated fadeIn">
    <loading v-if="vLoading" />
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text> </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-dialog v-model="returnModal" width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>برگشت فاکتور {{ selected.invoiceCode }} از فروش</h4>
        </v-card-title>
        <v-card-text>
          <v-container class="mt-4">
            <h5 class="text-right">آیا از برگشت فروش ثبت شده اطمینان دارید؟</h5>
            <div class="text-left pt-4">
              <v-btn class="red white--text mx-1" @click="returnModal = false"
                >خیر</v-btn
              >
              <v-btn
                color="primary"
                class="mx-1"
                :loading="busy"
                @click="submitReturn"
                >بله</v-btn
              >
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="convertModal" width="700">
      <v-card style="overflow-y: scroll; max-height: 80vh">
        <v-card-title class="text-center">
          <h4>تبدیل پیش فاکتور {{ selected.invoiceCode }} به فروش</h4>
        </v-card-title>
        <v-card-text>
          <v-container class="mt-4">
            <p>نوع فروش را انتخاب کنید:</p>
            <v-select
              label="نوع فروش"
              :items="sellingTypes"
              v-model="convert.sellingType"
              outlined
              dense
            />
            <v-select
              v-if="convert.sellingType == 'definite'"
              label="نوع پرداخت"
              @change="check = {}"
              :items="paymentTypes"
              v-model="convert.paymentTypes"
              outlined
              dense
            />
            <div
              v-if="convert.paymentTypes == 'cheque'"
              class="pa-5 pt-10 mb-2"
              style="
                border: 1px solid #ccc;
                border-radius: 7px;
                position: relative;
              "
            >
              <p
                class="px-4"
                style="position: absolute; top: -9px; background-color: #fff"
              >
                اطلاعات چک را وارد کنید:
              </p>
              <v-row>
                <v-col class="py-0" sm="6" cols="12">
                  <v-text-field
                    label="* شماره چک"
                    v-model="check.number"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

                <v-col class="py-0" sm="6" cols="12">
                  <v-text-field
                    label="* نام بانک"
                    v-model="check.bankName"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0" sm="6" cols="12">
                  <label>* تاریخ چک</label>
                  <date-picker
                    v-model="check.date"
                    :editable="true"
                  ></date-picker>
                </v-col>
                <v-col class="py-0" sm="6" cols="12">
                  <v-text-field
                    class="mt-7"
                    label="شماره صیاد"
                    v-model="check.chequeSayyad"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <br />
            <v-textarea
              outlined
              dense
              label="توضیحات"
              rows="3"
              v-model="selected.description"
            ></v-textarea>
            <div class="text-left">
              <v-btn class="red white--text mx-1" @click="convertModal = false"
                >لغو</v-btn
              >
              <v-btn
                color="primary"
                class="mx-1"
                :loading="busy"
                @click="submit"
                :disabled="computedBtn"
                >ثبت</v-btn
              >
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <b-card
      v-if="$router.currentRoute.path == '/shop/customer/' + $route.params.id"
    >
      <b-card class="h-100" :class="customer.customer_priority">
        <b-row>
          <b-col cols="6">
            <div class="py-3 px-4">
              <h4>نام مشتری: {{ customer.name }}</h4>
              <h4>تراز مالی: {{ balance }}</h4>
              <br />
              <h5>نوع مشتری: {{ customer.type }}</h5>
              <h5>کد: {{ customer.customerCode }}</h5>
            </div></b-col
          >
          <b-col cols="6">
            <div class="py-3 px-4">
              <h5>جمع کل خریدها: {{ totalInvoice }}</h5>
              <h5>تعداد کل خریدها: {{ invoicesTotalRows }}</h5>
              <h5>جمع کل پرداخت‌ها: {{ totalPayment }}</h5>
              <h5>تعداد کل پرداخت‌ها: {{ incomesTotalRows }}</h5>
            </div></b-col
          >
        </b-row>
        <hr />
        <b-row>
          <b-col cols="12">
            <div class="px-4">
              <h5>
                موبایل:
                {{ customer.mobile ? customer.mobile : "-" }}
              </h5>
              <h5>
                ایمیل:
                {{ customer.email ? customer.email : "-" }}
              </h5>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <b-tabs pills card content-class="mt-3">
        <b-tab title="فاکتورها" @click="filter = ''">
          <b-card header-bg-variant="primary" header-text-variant="white">
            <b-card class="shadow p-3 mb-5 bg-white rounded">
              <br />
              <b-table
                responsive
                show-empty
                :items="computedOrders(customer.shopInvoices, 'allOrders')"
                :fields="invoiceFields"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد"
                striped
                :current-page="invoicesCurrentPage"
                :per-page="perPage"
                :busy="isBusy"
              >
              
              <template slot="top-row" slot-scope="{ fields }">
                  <td v-for="field in fields" :key="field.key">
                    <b-form-input
                      v-if="field.key != 'index' && field.key != 'operation'"
                      v-model="toFilterData['allOrders'][field.key]"
                      @input="invoicesCurrentPage = 1"
                      :placeholder="field.label"
                    ></b-form-input>
                    <b-button
                      v-if="field.key == 'operation'"
                      :disabled="!Object.keys(toFilterData['allOrders']).length"
                      variant="danger"
                      @click="
                        toFilterData['allOrders'] = [];
                        invoicesCurrentPage = 1;
                      "
                      >بازنشانی
                    </b-button>
                  </td>
                </template>
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <v-btn
                      color="primary"
                      class="ml-1"
                      @click="print(data.item, 'invoice')"
                    >
                      چاپ رسید
                    </v-btn>
                    <b-btn
                      v-if="data.item.status != 'برگشت خورده'"
                      class="mr-1 red white--text"
                      @click="openModal(data.item)"
                      >برگشت از فروش</b-btn
                    >
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 + perPage * (invoicesCurrentPage - 1) }}
                  </div>
                </template>
                <div slot="table-isBusy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
              <div v-if="!isBusy" class="d-flex justify-content-center">
                <h6>تعداد: {{ computedOrders(customer.shopInvoices, 'allOrders').length }}</h6>
              </div>
              <b-pagination
                v-if="!isBusy"
                v-model="invoicesCurrentPage"
                :per-page="perPage"
                :total-rows="computedOrders(customer.shopInvoices, 'allOrders').length"
                align="center"
                size="md"
                class="my-0"
                aria-controls="orders-list"
              ></b-pagination>
            </b-card>
          </b-card>
        </b-tab>
        <b-tab title="پرداخت‌ها" @click="filter = ''">
          <b-card header-bg-variant="primary" header-text-variant="white">
            <b-card class="shadow p-3 mb-5 bg-white rounded">
              
              <br />
              <b-table
                responsive
                show-empty
                :items="computedOrders(customer.shopIncomes, 'allOrders')"
                :fields="paymentFields"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد"
                striped
                :current-page="incomesCurrentPage"
                :per-page="perPage"
                :busy="isBusy"
              >
              <template slot="top-row" slot-scope="{ fields }">
                <td v-for="field in paymentFields" :key="field.key">
                  <b-form-input
                    v-if="field.key != 'index' && field.key != 'operation'"
                    v-model="toFilterData['allOrders'][field.key]"
                    @input="incomesCurrentPage = 1"
                    :placeholder="field.label"
                  ></b-form-input>
                  <b-button
                    v-if="field.key == 'operation'"
                    :disabled="!Object.keys(toFilterData['allOrders']).length"
                    variant="danger"
                    @click="
                      toFilterData['allOrders'] = [];
                      incomesCurrentPage = 1;
                    "
                    >بازنشانی
                  </b-button>
                </td>
              </template>
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 + perPage * (incomesCurrentPage - 1) }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <v-btn color="primary" @click="paymentPrint(data.item)">
                      چاپ رسید
                    </v-btn>
                  </div>
                </template>
                <div slot="table-isBusy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
              <div v-if="!isBusy" class="d-flex justify-content-center">
                <h6>تعداد: {{ computedOrders(customer.shopIncomes, 'allOrders').length }}</h6>
              </div>
              <b-pagination
                v-if="!isBusy"
                v-model="incomesCurrentPage"
                :per-page="perPage"
                :total-rows="computedOrders(customer.shopIncomes, 'allOrders').length"
                align="center"
                size="md"
                class="my-0"
                aria-controls="orders-list"
              ></b-pagination>
            </b-card>
          </b-card>
        </b-tab>
        <b-tab title="پیش فاکتورها" @click="filter = ''">
          <b-card header-bg-variant="primary" header-text-variant="white">
            <b-card class="shadow p-3 mb-5 bg-white rounded">
              
              <b-table
                responsive
                show-empty
                :items="computedOrders(customer.proformaInvoices, 'allOrders')"
                :fields="proformaInvoiceFields"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد"
                striped
                :current-page="proformaCurrentPage"
                :per-page="perPage"
                :busy="isBusy"
              >
              
              <template slot="top-row" slot-scope="{ fields }">
                <td v-for="field in fields" :key="field.key">
                  <b-form-input
                    v-if="field.key != 'index' && field.key != 'operation'"
                    v-model="toFilterData['allOrders'][field.key]"
                    @input="proformaCurrentPage = 1"
                    :placeholder="field.label"
                  ></b-form-input>
                  <b-button
                    v-if="field.key == 'operation'"
                    :disabled="!Object.keys(toFilterData['allOrders']).length"
                    variant="danger"
                    @click="
                      toFilterData['allOrders'] = [];
                      proformaCurrentPage = 1;
                    "
                    >بازنشانی
                  </b-button>
                </td>
              </template>
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 + perPage * (proformaCurrentPage - 1) }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <v-btn
                      class="ml-1"
                      color="primary"
                      @click="print(data.item, 'preInvoice')"
                    >
                      چاپ رسید
                    </v-btn>
                    <b-btn
                      class="mr-1 red white--text"
                      @click="openConvertModal(data.item)"
                      >تبدیل به فروش</b-btn
                    >
                  </div>
                </template>
                <div slot="table-isBusy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
              <div v-if="!isBusy" class="d-flex justify-content-center">
                <h6>تعداد: {{ computedOrders(customer.proformaInvoices, 'allOrders').length }}</h6>
              </div>
              <b-pagination
                v-if="!isBusy"
                v-model="proformaCurrentPage"
                :per-page="perPage"
                :total-rows="computedOrders(customer.proformaInvoices, 'allOrders').length"
                align="center"
                size="md"
                class="my-0"
                aria-controls="orders-list"
              ></b-pagination>
            </b-card>
          </b-card>
        </b-tab>
      </b-tabs>
      <br />
      <!-- receipt -->
      <v-card class="pa-2" style="direction: rtl" v-show="false" id="Receipt">
        <b-card
          style="border: 1px solid black; border-radius: 15px; padding: 10px"
        >
          <table style="border: 0px solid black !important">
            <tr>
              <td style="border: 0px solid black !important">
                <span>نام مشتری: {{ customer.name }}</span>
              </td>
              <td style="border: 0px solid black !important">
                <span>نوع مشتری: {{ customer.type }}</span>
              </td>
            </tr>
            <tr>
              <td style="border: 0px solid black !important">
                <span>کد: {{ customer.customerCode }}</span>
              </td>
              <td style="border: 0px solid black !important">
                <span
                  >موبایل: {{ customer.mobile ? customer.mobile : "-" }}</span
                >
              </td>
            </tr>
          </table>
        </b-card>
        <br />
        <hr />
        <br />
        <b-card
          header-bg-variant="primary"
          header-text-variant="white"
          v-if="customer.shopInvoices"
        >
          <template v-slot:header>
            <h3>فاکتورهای مشتری - {{ customer.shopInvoices.length }} عدد</h3>
          </template>
          <b-table
            v-if="customer.shopInvoices.length"
            responsive
            show-empty
            :items="customer.shopInvoices"
            :fields="receiptInvoiceFields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :busy="isBusy"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 + perPage * (invoicesCurrentPage - 1) }}
              </div>
            </template>
            <div slot="table-isBusy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
        </b-card>
        <hr />
        <b-card
          header-bg-variant="primary"
          header-text-variant="white"
          v-if="customer.shopIncomes"
        >
          <template v-slot:header>
            <h3>پرداخت‌های مشتری - {{ customer.shopIncomes.length }} عدد</h3>
          </template>
          <b-table
            v-if="customer.shopIncomes.length"
            responsive
            show-empty
            :items="customer.shopIncomes"
            :fields="receiptPaymentFields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :busy="isBusy"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 + perPage * (incomesCurrentPage - 1) }}
              </div>
            </template>
            <div slot="table-isBusy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
        </b-card>
        <hr />
        <b-card
          header-bg-variant="primary"
          header-text-variant="white"
          v-if="customer.proformaInvoices"
        >
          <template v-slot:header>
            <h3>
              پیش فاکتورهای مشتری - {{ customer.proformaInvoices.length }} عدد
            </h3>
          </template>
          <b-table
            v-if="customer.proformaInvoices.length"
            responsive
            show-empty
            :items="customer.proformaInvoices"
            :fields="receiptProformaInvoiceFields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :busy="isBusy"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 + perPage * (proformaCurrentPage - 1) }}
              </div>
            </template>
            <div slot="table-isBusy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
        </b-card>
        <br />
        <hr />
        <br />

        <table style="border: 0px solid black !important; break-inside: avoid">
          <tr>
            <td style="border: 0px solid black !important">
              <span>جمع کل خریدها: {{ totalInvoice }}</span>
            </td>
            <td style="border: 0px solid black !important">
              <span>تعداد کل خریدها: {{ invoicesTotalRows }}</span>
            </td>
          </tr>
          <tr>
            <td style="border: 0px solid black !important">
              <span>جمع کل پرداخت‌ها: {{ totalPayment }}</span>
            </td>
            <td style="border: 0px solid black !important">
              <span>تعداد کل پرداخت‌ها: {{ incomesTotalRows }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="border: 0px solid black !important">
              <span>تراز مالی: {{ balance }}</span>
            </td>
          </tr>
        </table>
      </v-card>

      <v-card>
        <div id="preInvoiceReceipt" v-show="false">
          <table class="mainTable m-3 p-4 h-100 w-100">
            <thead>
              <tr>
                <td>
                  <div style="text-align: center; width: 100%">
                    <span style="font-size: 22px">فروشگاه پولاد پیچکار</span>
                  </div>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div class="content" style="padding: 15px">
                    <div
                      style="
                        border: 1px solid black;
                        border-radius: 10px;
                        padding: 0 10px;
                        margin-bottom: 10px;
                      "
                    >
                      <div style="text-align: center">
                        <span style="font-size: 20px">پیش فاکتور</span>
                      </div>
                      <br />
                      <div>
                        <table style="border: 0px solid black !important">
                          <tr>
                            <td style="border: 0px solid black !important">
                              نام مشتری:
                              <span style="font-size = 16px">{{
                                printInvoice.shopCustomerName
                              }}</span>
                            </td>
                            <td
                              style="
                                border: 0px solid black !important;
                                text-align: left;
                              "
                            >
                              شماره فاکتور:
                              <span style="font-size = 16px">{{
                                printInvoice.code
                              }}</span>
                              (چاپ مجدد)
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 0px solid black !important">
                              کد مشتری:
                              <span style="font-size = 16px">{{
                                printInvoice.shopCustomerCode
                              }}</span>
                            </td>
                            <td
                              style="
                                border: 0px solid black !important;
                                text-align: left;
                              "
                            >
                              تاریخ صدور:
                              <span style="font-size = 16px">{{
                                printInvoice.date
                              }}</span>
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 0px solid black !important">
                              نوع مشتری:
                              <span style="font-size = 16px">{{
                                printInvoice.shopCustomerType
                              }}</span>
                            </td>
                            <td
                              style="
                                border: 0px solid black !important;
                                text-align: left;
                              "
                            >
                              ساعت صدور:
                              <span style="font-size = 16px">{{
                                printInvoice.time
                              }}</span>
                            </td>
                          </tr>
                        </table>
                      </div>
                      <br />
                      <div>
                        <span style="float: right"> </span>
                        <span style="float: left"> </span>
                      </div>
                    </div>
                    <b-table
                      bordered
                      :fields="preInvoiceSelectedFields"
                      :items="printInvoice.details"
                      small="small"
                      responsive
                    >
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell(name)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(amount)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ Number(data.value).toLocaleString() }}
                        </div>
                      </template>
                      <template v-slot:cell(price)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value.toLocaleString() }} ریال
                        </div>
                      </template>
                      <template v-slot:cell(totalPrice)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{
                            (
                              Number(data.item.amount) * data.item.price
                            ).toLocaleString()
                          }}
                          ریال
                        </div>
                      </template>
                    </b-table>
                    <br />
                    <div>
                      <span>
                        نوع فاکتور:
                        {{ printInvoice.type }}
                      </span>
                      <span style="float: left">
                        {{
                          "مبلغ کل: " +
                          Number(printInvoice.totalCost).toLocaleString()
                        }}
                        ریال
                      </span>
                    </div>
                    <br />
                    <div
                      style="
                        border: 1px solid black;
                        border-radius: 10px;
                        padding: 10px;
                        min-height: 75px;
                        break-inside: avoid;
                      "
                    >
                      <span> توضیحات: {{ printInvoice.description }}</span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-card>
      <v-card>
        <div id="invoiceReceipt" v-show="false">
          <table class="mainTable m-3 p-4 h-100 w-100">
            <thead>
              <tr>
                <td>
                  <div style="text-align: center; width: 100%">
                    <span style="font-size: 22px">فروشگاه پولاد پیچکار</span>
                  </div>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div class="content" style="padding: 15px">
                    <div
                      style="
                        border: 1px solid black;
                        border-radius: 10px;
                        padding: 0 10px;
                        margin-bottom: 10px;
                      "
                    >
                      <div style="text-align: center">
                        <span style="font-size: 20px">فاکتور فروش</span>
                      </div>
                      <div>
                        <br />
                        <table style="border: 0px solid black !important">
                          <tr>
                            <td style="border: 0px solid black !important">
                              نام مشتری:
                              <span style="font-size = 16px">{{
                                printInvoice.shopCustomerName
                              }}</span>
                            </td>
                            <td
                              style="
                                border: 0px solid black !important;
                                text-align: left;
                              "
                            >
                              شماره فاکتور:
                              <span style="font-size = 16px">{{
                                printInvoice.code
                              }}</span>
                              (چاپ مجدد)
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 0px solid black !important">
                              کد مشتری:
                              <span style="font-size = 16px">{{
                                printInvoice.shopCustomerCode
                              }}</span>
                            </td>
                            <td
                              style="
                                border: 0px solid black !important;
                                text-align: left;
                              "
                            >
                              تاریخ صدور:
                              <span style="font-size = 16px">{{
                                printInvoice.date
                              }}</span>
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 0px solid black !important">
                              نوع مشتری:
                              <span style="font-size = 16px">{{
                                printInvoice.shopCustomerType
                              }}</span>
                            </td>
                            <td
                              style="
                                border: 0px solid black !important;
                                text-align: left;
                              "
                            >
                              ساعت صدور:
                              <span style="font-size = 16px">{{
                                printInvoice.time
                              }}</span>
                            </td>
                          </tr>
                        </table>

                        <br />
                      </div>
                    </div>
                    <b-table
                      bordered
                      :fields="selectedFields"
                      :items="printInvoice.details"
                      small="small"
                      responsive
                    >
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell(name)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(amount)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ Number(data.value).toLocaleString() }}
                        </div>
                      </template>
                      <template v-slot:cell(price)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value.toLocaleString() }} ریال
                        </div>
                      </template>
                      <template v-slot:cell(totalPrice)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{
                            (
                              Number(data.item.amount) * data.item.price
                            ).toLocaleString()
                          }}
                          ریال
                        </div>
                      </template>
                    </b-table>
                    <br />
                    <table
                      v-if="printInvoice.income"
                      style="
                        border: 0px solid black !important;
                        break-inside: avoid;
                      "
                    >
                      <tr>
                        <td
                          v-if="printInvoice.income.type == 'چک'"
                          style="border: 0px solid black !important"
                        >
                          <span>
                            {{ "شیوه پرداخت: " + printInvoice.income.type }}
                          </span>
                        </td>
                        <td
                          v-if="printInvoice.income.type == 'چک'"
                          style="border: 0px solid black !important"
                        >
                          <span>
                            {{ "شماره چک: " + printInvoice.income.chequeNo }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td
                          v-if="printInvoice.income.type == 'چک'"
                          style="border: 0px solid black !important"
                        >
                          <span>
                            {{ "نام بانک: " + printInvoice.income.chequeBank }}
                          </span>
                        </td>
                        <td
                          v-if="printInvoice.income.type == 'چک'"
                          style="border: 0px solid black !important"
                        >
                          <span>
                            {{
                              "شماره صیاد: " + printInvoice.income.chequeSayyad
                            }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td
                          v-if="printInvoice.income.type == 'چک'"
                          style="border: 0px solid black !important"
                        >
                          <span>
                            {{ "تاریخ چک: " + printInvoice.income.chequeDate }}
                          </span>
                        </td>
                      </tr>
                      <tr></tr>
                    </table>

                    <div v-if="printInvoice.income">
                      <span>
                        {{
                          "مبلغ کل: " +
                          Number(printInvoice.totalCost).toLocaleString()
                        }}
                        ریال
                      </span>
                      <div
                        v-if="printInvoice.income.type != 'چک'"
                        style="float: left"
                      >
                        <span>
                          نوع پرداخت:
                          {{
                            printInvoice.type == "قطعی"
                              ? "قطعی - پرداخت در لحظه"
                              : "امانی - پرداخت اعتباری"
                          }}
                        </span>
                        <span v-if="printInvoice.type == 'قطعی'">{{
                          " (" + printInvoice.income.type + ")"
                        }}</span>
                      </div>
                    </div>
                    <br />
                    <div
                      style="
                        border: 1px solid grey;
                        border-radius: 10px;
                        min-height: 80px;
                        padding: 10px;
                        break-inside: avoid;
                      "
                    >
                      <span> توضیحات: {{ printInvoice.description }}</span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-card>
      <v-card v-show="false" id="paymentReceipt">
        <div
          class="container mb-0"
          style="border: 2px solid rgb(200, 200, 200)"
        >
          <div style="text-align: center">
            <span style="font-size: 22px">فروشگاه پولاد پیچکار</span>
          </div>
          <hr />

          <div style="padding: 0 15px">
            <div style="direction: rtl">
              <div
                style="
                  border: 1px solid black;
                  border-radius: 10px;
                  padding: 0 10px;
                  margin-bottom: 10px;
                "
              >
                <div style="text-align: center">
                  <span style="font-size: 19px"> رسید پرداخت (چاپ مجدد) </span>
                </div>
                <br />
                <div>
                  <table
                    style="
                      border: 0px solid black !important;
                      break-inside: avoid;
                    "
                  >
                    <tr>
                      <td style="border: 0px solid black !important">
                        نام مشتری:
                        {{ printPayment.shopCustomerName }}
                      </td>
                      <td
                        style="
                          border: 0px solid black !important;
                          text-align: left;
                        "
                      >
                        تاریخ:
                        {{
                          printPayment.date
                            ? printPayment.date.split(" ")[0]
                            : ""
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td style="border: 0px solid black !important">
                        کد مشتری:
                        {{ printPayment.shopCustomerCode }}
                      </td>
                      <td
                        style="
                          border: 0px solid black !important;
                          text-align: left;
                        "
                      >
                        ساعت:
                        {{
                          printPayment.date
                            ? printPayment.date.split(" ")[1]
                            : ""
                        }}
                      </td>
                    </tr>
                  </table>

                  <br />
                </div>
              </div>
              <br />
              <div style="padding: 0 10px">
                <table
                  style="
                    border: 0px solid black !important;
                    break-inside: avoid;
                  "
                >
                  <tr>
                    <td
                      v-if="printPayment.type == 'چک'"
                      style="border: 0px solid black !important"
                    >
                      <span>شیوه پرداخت: {{ printPayment.type }}</span>
                    </td>
                    <td
                      v-if="printPayment.type == 'چک'"
                      style="border: 0px solid black !important"
                    >
                      <span>{{ "شماره چک: " + printPayment.chequeNo }}</span>
                    </td>
                  </tr>
                  <tr v-if="printPayment.type == 'چک'">
                    <td style="border: 0px solid black !important">
                      <span>{{
                        "شماره صیاد: " + printPayment.chequeSayyad
                      }}</span>
                    </td>
                    <td style="border: 0px solid black !important">
                      <span>{{ "نام بانک: " + printPayment.chequeBank }}</span>
                    </td>
                  </tr>
                  <tr v-if="printPayment.type == 'چک'">
                    <td style="border: 0px solid black !important">
                      <span>{{ "تاریخ چک: " + printPayment.chequeDate }}</span>
                    </td>
                  </tr>
                </table>

                <table style="border: 0px solid black !important">
                  <tr>
                    <td style="border: 0px solid black !important">
                      مبلغ پرداخت: {{ printPayment.amount }} ریال
                    </td>
                    <td
                      v-if="printPayment.type != 'چک'"
                      style="
                        border: 0px solid black !important;
                        text-align: left;
                      "
                    >
                      <span>شیوه پرداخت: {{ printPayment.type }}</span>
                    </td>
                  </tr>
                </table>
              </div>
              <div
                style="
                  border: 1px solid grey;
                  border-radius: 10px;
                  min-height: 80px;
                  padding: 10px;
                  margin-top: 15px
                  break-inside: avoid
                "
              >
                <span>توضیحات: {{ printPayment.description }}</span>
              </div>
              <br />
            </div>
          </div>
        </div>
      </v-card>
      <v-card>
        <div id="convertReceipt" v-show="false">
          <table class="mainTable m-3 p-4 h-100 w-100">
            <thead>
              <tr>
                <td>
                  <div style="text-align: center; width: 100%">
                    <span style="font-size: 22px">فروشگاه پولاد پیچکار</span>
                  </div>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div class="content" style="padding: 15px">
                    <div
                      style="
                        border: 1px solid black;
                        border-radius: 10px;
                        padding: 0 10px;
                        margin-bottom: 10px;
                      "
                    >
                      <div style="text-align: center">
                        <span style="font-size: 20px">فاکتور فروش</span>
                      </div>
                      <div>
                        <br />
                        <table style="border: 0px solid black !important">
                          <tr>
                            <td style="border: 0px solid black !important">
                              نام مشتری:
                              <span style="font-size = 16px">{{
                                printInvoice.shopCustomerName
                              }}</span>
                            </td>
                            <td
                              style="
                                border: 0px solid black !important;
                                text-align: left;
                              "
                            >
                              شماره فاکتور:
                              <span style="font-size = 16px">{{
                                printInvoice.code
                              }}</span>
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 0px solid black !important">
                              کد مشتری:
                              <span style="font-size = 16px">{{
                                printInvoice.shopCustomerCode
                              }}</span>
                            </td>
                            <td
                              style="
                                border: 0px solid black !important;
                                text-align: left;
                              "
                            >
                              تاریخ صدور:
                              <span style="font-size = 16px">{{
                                selected.date
                              }}</span>
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 0px solid black !important">
                              نوع مشتری:
                              <span style="font-size = 16px">{{
                                printInvoice.shopCustomerType
                              }}</span>
                            </td>
                            <td
                              style="
                                border: 0px solid black !important;
                                text-align: left;
                              "
                            >
                              ساعت صدور:
                              <span style="font-size = 16px">{{
                                printInvoice.time
                              }}</span>
                            </td>
                          </tr>
                        </table>

                        <br />
                      </div>
                    </div>
                    <br />

                    <table
                      v-if="convert.paymentTypes == 'cheque'"
                      style="
                        border: 0px solid black !important;
                        break-inside: avoid;
                      "
                    >
                      <tr>
                        <td style="border: 0px solid black !important">
                          <span>
                            {{ "شیوه پرداخت: چک" }}
                          </span>
                        </td>
                        <td style="border: 0px solid black !important">
                          <span>
                            {{ "شماره چک: " + check.number }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 0px solid black !important">
                          <span>
                            {{ "نام بانک: " + check.bankName }}
                          </span>
                        </td>
                        <td style="border: 0px solid black !important">
                          <span>
                            {{ "شماره صیاد: " + check.chequeSayyad }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 0px solid black !important">
                          <span>
                            {{ "تاریخ چک: " + check.date }}
                          </span>
                        </td>
                      </tr>
                      <tr></tr>
                    </table>

                    <div>
                      <span>
                        {{ "مبلغ کل: " + selected.totalCost }}
                        ریال
                      </span>
                      <span
                        v-if="convert.paymentTypes != 'cheque'"
                        style="float: left"
                      >
                        نوع پرداخت:
                        {{
                          convert.sellingType == "definite"
                            ? "قطعی - پرداخت در لحظه"
                            : "امانی - پرداخت اعتباری"
                        }}
                        <span v-if="convert.sellingType == 'definite'">{{
                          " (" +
                          (convert.paymentTypes == "cash"
                            ? "نقدی"
                            : "کارتخوان") +
                          ")"
                        }}</span>
                      </span>
                    </div>
                    <br />
                    <div
                      style="
                        border: 1px solid grey;
                        border-radius: 10px;
                        min-height: 80px;
                        padding: 10px;
                        break-inside: avoid;
                      "
                    >
                      <span> توضیحات: {{ printInvoice.description }}</span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-card>
      <!-- receipt -->
      <v-btn
        color="primary"
        @click="
          receiptType = 'total';
          printReceipt();
        "
        >پرینت</v-btn
      >
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";

import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import moment from "moment-jalaali";

export default {
  components: {
  
    datePicker: VuePersianDatetimePicker,
  },
  data: function () {
    return {
      guide: false,

      invoiceFields: [
        { key: "index", label: "ردیف" },
        { key: "invoiceCode", label: "کد فاکتور" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "totalCost", label: "مبلغ (ریال)" },
        { key: "type", label: "نوع فاکتور" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      receiptInvoiceFields: [
        { key: "index", label: "ردیف" },
        { key: "invoiceCode", label: "کد فاکتور" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "totalCost", label: "مبلغ (ریال)" },
        { key: "type", label: "نوع فاکتور" },
        { key: "status", label: "وضعیت" },
      ],
      proformaInvoiceFields: [
        { key: "index", label: "ردیف" },
        { key: "invoiceCode", label: "کد فاکتور" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "expirationDate", label: "تاریخ اعتبار" },
        { key: "totalCost", label: "مبلغ (ریال)" },
        { key: "type", label: "نوع فاکتور" },
        { key: "operation", label: "عملیات" },
      ],
      receiptProformaInvoiceFields: [
        { key: "index", label: "ردیف" },
        { key: "invoiceCode", label: "کد فاکتور" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "expirationDate", label: "تاریخ اعتبار" },
        { key: "totalCost", label: "مبلغ (ریال)" },
        { key: "type", label: "نوع فاکتور" },
        // { key: "operation", label: "عملیات" }
      ],
      paymentFields: [
        { key: "index", label: "ردیف" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "description", label: "توضیحات" },
        { key: "amount", label: "مبلغ" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      receiptPaymentFields: [
        { key: "index", label: "ردیف" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "description", label: "توضیحات" },
        { key: "amount", label: "مبلغ" },
        { key: "status", label: "وضعیت" },
      ],
      selectedFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام" },
        { key: "price", label: "قیمت" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "قیمت کل" },
        // { key: "sum", label: "موجودی" },
        // { key: "operation", label: "عملیات" },
      ],
      currentPage: 1,
      proformaCurrentPage: 1,
      invoicesCurrentPage: 1,
      incomesCurrentPage: 1,
      perPage: 10,
      isBusy: true,
      invoicesTotalRows: "",
      incomesTotalRows: "",
      proformaTotalRows: "",
      balance: "",
      content: "",
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },
      filter: "",
      returnModal: false,
      sortBy: "",
      userInput: "",
      selected: "",
      fields2: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام رابط" },
        // { key: "internal", label: "داخلی" },
        { key: "role", label: "سمت" },
        // { key: "phone", label: "تلفن" },
        // { key: "phone2", label: "تلفن 2" },
        // { key: "fax", label: "فاکس" },
        { key: "mobile", label: "موبایل" },
        // { key: "email", label: "ایمیل" },
        // { key: "address", label: "آدرس" },
        // { key: "postalCode", label: "کد پستی" },
        // { key: "operation", label: "عملیات" },
      ],
      agents: [],
      role: "",
      toCustomerDialog: false,
      selected: "",
      newAgentDialog: false,
      filterBusy: false,
      progress: false,
      agent: {},
      newAgent: {},
      editAgent: {},
      customerOrders: [],
      customer: "",
      invoiceType: "definite",
      invoiceTypes: [
        { value: "definite", text: "قطعی - پرداخت در لحظه" },
        { value: "respite", text: "امانی - پرداخت اعتباری" },
      ],
      customerTypes: [
        { value: "naturalPerson", text: "حقیقی" },
        { value: "legalPerson", text: "حقوقی" },
      ],
      totalInvoice: "",
      totalPayment: "",
      receiptType: "",
      printInvoice: {},
      printPayment: {},
      preInvoiceSelectedFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام" },
        { key: "price", label: "قیمت" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "قیمت کل" },
        // { key: "sum", label: "موجودی" },
        // { key: "operation", label: "عملیات" }
      ],
      convert: {},
      busy: false,
      check: {},
      convertModal: false,
      sellingTypes: [
        { value: "definite", text: "قطعی - پرداخت در لحظه" },
        { value: "respite", text: "امانی - پرداخت اعتباری" },
      ],
      paymentTypes: [
        { value: "cash", text: "نقدی" },
        { value: "card", text: "کارتخوان" },
        { value: "cheque", text: "چک" },
      ],
      toFilterData: {
        allOrders: [],
      },
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    onFilteredContact(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPageContact = 1;
    },
    onFilteredOrder(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.ordersTotalRows = filteredItems.length;
      this.currentPageOrder = 1;
    },
    onFilteredHistory(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.historyTotalRows = filteredItems.length;
      this.currentHistoryPage = 1;
    },
    onFilteredInvoices(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.invoicesTotalRows = filteredItems.length;
      this.invoicesCurrentPage = 1;
    },
    onFilteredIncomes(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.incomesTotalRows = filteredItems.length;
      this.incomesCurrentPage = 1;
    },
    onFilteredProforma(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.proformaTotalRows = filteredItems.length;
      this.proformaCurrentPage = 1;
    },
    openModal(item) {
      this.returnModal = true;
      this.selected = item;
    },
    openConvertModal(item) {
      this.convert = {};
      this.check = {};
      this.convertModal = true;
      this.selected = item;
    },
    submit() {
      let current = moment(new Date()).format("jYYYY/jMM/jDD");
      if (this.selected.expirationDate < current) {
        this.toast("پیش فاکتور معتبر نمی باشد", "error");
      } else {
        this.busy = true;
        Axios.post(
          this.baseUrl + "/ppkpms/shop/sales/convertProforma",
          {
            shopInvoiceId: this.selected.id,
            type: this.convert.sellingType,
            paymentType: this.convert.paymentTypes,
            chequeNo: this.check.number ? this.check.number : "",
            chequeDate: this.check.date ? this.check.date : "",
            chequeSayyad: this.check.chequeSayyad
              ? this.check.chequeSayyad
              : "",
            chequeBank: this.check.bankName ? this.check.bankName : "",
            description: this.selected.description
              ? this.selected.description
              : "",
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            this.busy = false;
            if (res.status == 201) {
              this.toast(res.data, "success");
              this.convertModal = false;
              this.getCustomerInfo();
            } else {
              const title = (
                <div>
                  <h5>خطا </h5>
                  <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
                </div>
              );
              this.toast(title, "error");
            }
          })
          .then(() => {
            this.print(this.selected, "convertReceipt");
          })
          .catch((err) => {
            this.busy = false;
            this.toast(err.response.data, "error");
          });
      }
    },
    submitReturn() {
      this.busy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/sales/return",
        {
          shopInvoiceId: this.selected.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.returnModal = false;
            this.getCustomerInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
          this.busy = false;
        });
    },
    paymentPrint(item) {
      this.gettingReceipt = true;
      this.receiptType = "payment";
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/getInfo",
        {
          shopIncomeId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printPayment = res.data;
            // this.printPaymentIncome = res.data.income;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .then(() => {
          this.printReceipt();
        })
        .catch((err) => {
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    print(item, type) {
      this.gettingReceipt = true;
      this.receiptType = type;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/sales/getInfo",
        {
          shopInvoiceId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printInvoice = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .then(() => {
          this.printReceipt();
        })
        .catch((err) => {
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "Receipt", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;text-align: right;} table, td, th {border: 1px solid black; border-radius: 5px} tr{ page-break-inside:avoid; page-break-after:auto } thead { display:table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title>Receipt</title>"
      );
      myWindow.document.write("</head><body>");
      if (this.receiptType == "total") {
        myWindow.document.write(document.getElementById("Receipt").innerHTML);
      } else if (this.receiptType == "preInvoice") {
        myWindow.document.write(
          document.getElementById("preInvoiceReceipt").innerHTML
        );
      } else if (this.receiptType == "invoice") {
        myWindow.document.write(
          document.getElementById("invoiceReceipt").innerHTML
        );
      } else if (this.receiptType == "payment") {
        myWindow.document.write(
          document.getElementById("paymentReceipt").innerHTML
        );
      } else if (this.receiptType == "convertReceipt") {
        myWindow.document.write(
          document.getElementById("convertReceipt").innerHTML
        );
      }
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    sarmadNumber2(data) {
      let myCurrency = data.currency
        ? data.currency == "-"
          ? "ریال"
          : data.currency
        : "ریال";
      try {
        let temp1 = parseFloat(data.perPrice).toFixed(
          this.currencyOptions.filter((x) => x.value == myCurrency)[0].precision
        );
        return parseFloat(temp1) ? parseFloat(temp1).toLocaleString() : "--";
      } catch (error) {
        return "---";
      }
    },
    openEditDialog() {
      this.editAgentDialog = true;
      this.editAgent = JSON.parse(JSON.stringify(this.agent));
    },
    delFilter() {
      this.sortBy = "";
      this.userInput = "";
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/agents/getByCustomer",
        { customerId: this.$route.params.id },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.agents = res.data;
            this.TotalRows = this.agents.length;
            this.staticTotalRows = this.agents.length;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    delAgent() {
      this.agentDialog = false;
      this.deleteMassageDialog = false;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/agent/delete",
        {
          contactId: this.selected,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            const title = (
              <div>
                <h5>حذف مخاطب</h5>
                <span>.مخاطب با موفقیت حذف شد</span>
              </div>
            );
            this.toast(title, "success");
            this.showAgents();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.isBusy = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    getCustomerInfo() {
      this.vLoading = true;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customer/getInfo",
        { shopCustomerId: this.$route.params.id },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          this.vLoading = false;
          if (res.status == 200) {
            this.customer = res.data;

            this.proformaTotalRows = this.customer.proformaInvoices.length;
            try {
              this.customer.type = this.customerTypes.filter(
                (x) => x.value == this.customer.type
              )[0].text;
            } catch (error) {
              this.customer.type = "-";
            }

            this.totalInvoice =
              this.customer.shopInvoices
                .filter((y) => y.status != "برگشت خورده")
                .map((x) => x.totalCost.split(",").join(""))
                .reduce((a, b) => Number(a) + Number(b), 0)
                .toLocaleString() + " ریال";

            this.invoicesTotalRows = this.customer.shopInvoices.filter(
              (y) => y.status != "برگشت خورده"
            ).length;

            this.totalPayment =
              this.customer.shopIncomes
                .filter((y) => y.status != "برگشت خورده")
                .map((x) => x.amount.split(",").join(""))
                .reduce((a, b) => Number(a) + Number(b), 0)
                .toLocaleString() + " ریال";

            this.incomesTotalRows = this.customer.shopIncomes.filter(
              (y) => y.status != "برگشت خورده"
            ).length;
            try {
              this.balance =
                this.customer.shopInvoices
                  .filter((y) => y.status != "برگشت خورده")
                  .map((x) => x.totalCost.split(",").join(""))
                  .reduce((a, b) => Number(a) + Number(b), 0) -
                this.customer.shopIncomes
                  .filter((y) => y.status != "برگشت خورده")
                  .map((x) => x.amount.split(",").join(""))
                  .reduce((a, b) => Number(a) + Number(b), 0);
              if (this.balance.toLocaleString() == this.customer.balance) {
                if (this.balance > 0) {
                  this.balance =
                    Math.abs(this.balance).toLocaleString() + " ریال بدهکار";
                } else if (this.balance < 0) {
                  this.balance =
                    Math.abs(this.balance).toLocaleString() + " ریال بستانکار";
                } else {
                  this.balance = "تسویه";
                }
              } else {
                this.balance = "خطا در محاسبات - با پشتیبانی تماس بگیرید";
              }
            } catch (error) {
              this.balance = "خطا در محاسبات - با پشتیبانی تماس بگیرید";
            }
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    
    computedOrders(orders, status) {
      let myAllOrders = orders;
      if (myAllOrders.length) {
        try {
          myAllOrders = myAllOrders.filter((item) => {
            return Object.keys(this.toFilterData[status]).every((key) =>
              String(item[key])
                .toLowerCase()
                .includes(this.toFilterData[status][key].toLowerCase())
            );
          });
        } catch (error) {
          console.log(error);
          myAllOrders = [];
        }
      }

      return myAllOrders;
    },
  },
  computed: {
    computedBtn() {
      if (this.convert.paymentTypes == "cheque") {
        if (!this.check.number || !this.check.bankName || !this.check.date) {
          return true;
        } else return false;
      }
    },
  },
  mounted() {
    this.getCustomerInfo();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.v-select .v-input__slot fieldset {
  background-color: white !important;
}
.v-selectt .v-text-field__details {
  display: none !important;
}
</style>
<style scoped>
button.btn.btn-link {
  color: #1976d2 !important;
}

.VIP {
  background-color: rgb(150, 111, 13);
  color: white;
}

.معمولی {
  background-color: rgb(3, 25, 135);
  color: white;
}

.لیست {
  background-color: rgb(224, 10, 10);
  color: black;
}
</style>
